import {
    CONV_STORAGE,
    room,
    stopMediaPlayers,
    Video,
    convertPath,
    electronConfig,
    isElectron,
    localRecording,
    live_stream,
    permissions,
  } from "./roomnew.js"; //card 599
  import moment from "moment";
  import axios from "axios";
  import { EmojiButton } from "@joeattardi/emoji-button";
  import sanitizeHtml from "sanitize-html";
  import Main from "../features/chat-popup/Main.js";
import { initAddParticipantMenuEvent } from "../features/chat/addParticipantMenu.js";
import { debounceSearchChats, renderChatsList, setSelectedChatActive, updateChatBadge } from "../features/chat/chatsList.js";
import { addMembersFromMenu, createGroupChatFromMenu } from "../features/chat/functions.js";

  var CryptoJS = require("crypto-js");

  const download = require("downloadjs");
  export default class Chat {
    constructor() {
      this.mainChat = new Main();
      this.participantID = null;
      this.selectedParticipantsToMessage = []; // participants at the top of the search screen
      this.selectedChatId = null; // selected chat that we are currently texting
      this.groups = [];
      this.messages = {};
      // card 451
      this.encryptedMessages = [{ recipients: [], messages: [] }];
      // end card 451
      this.leftChatParticipants = [];
      this.groupReads = [];
      this.myUniqueId = null;
      this.events();
      this.participantNames = [];
      this.previousNotificationCount = []; // storing previous notifications for groups
      this.previousNotificationCountPanel = []; // storing previous notifications for groups
      this.chatPanelStatus = "closed"; // opened | closed
      this.lastSelectedChatId = false;
      this.profileImgUser = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 13C6 13 3 18 3 18C3 18 6 22 12 22C18 22 21 18 21 18C21 18 18 13 12 13Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 6.44444C16.5 8.9 14.4855 10.8889 12 10.8889C9.5145 10.8889 7.5 8.9 7.5 6.44444C7.5 3.98889 9.5145 2 12 2C14.4847 2 16.5 3.98963 16.5 6.44444Z" fill="white"/></svg>`;

      // card 415
      this.sendMessageStatus = false; // if user can send message or not because the text field may be empty
      // end card 415

      //this.notificationSound = new Audio('/sounds/chat.mp3');
      // this.sounds=new KinoSound();
      this.groupNotifications = [];
      this.chatButtonNotifications = 0;
      this.toggleChatNotifications = 0;

      this.sendingMessageStatus = false;

      this.messageQueue = [];

      this.sanitizeNoOptions = {
        allowedTags: [],
        allowedAttributes: {
          span: [],
          img: [],
        },
        allowedSchemesByTag: {
          img: [],
        },
      };

      this.failedMessages = [{}];

      /**
       *      System Settings
       *
       */
      // we are trying to create a group in the database
      this.creatingGroupStatus = false;

      // setting up emojis
      // setting up emojis
      let emoji_button = document.querySelector("#view-emojis-btn");
      let emoji_picker = new EmojiButton({
        rootElement: document.querySelector("#conversationsScroller"),
        autoHide: false,
        emojiSize: "25px",
        showVariants: true,
        theme: "dark",
      });

      emoji_picker.on("emoji", (emoji) => {
        $("#message-text-field").append(
          `<span class="emoji-icon" contenteditable="false">${emoji.emoji}</span>`
        );
        $(
          "#conversationsScroller .emoji-picker__wrapper .emoji-picker__search"
        ).focus();
        // card 415
        this.toggleChatSendMessageIcon();
        // card 415
      });
      emoji_button.addEventListener("click", (e) => {
        emoji_picker.pickerVisible
          ? emoji_picker.hidePicker()
          : emoji_picker.showPicker(emoji_button);
      });
    }

    // card 415

    toggleChatSendMessageIcon() {
      if (
        $("#attachment-container").children().length ||
        $("#message-text-field").html().trim().length
      ) {
        $('#send-message-form .send-message button[type="submit"]').attr(
          "disabled",
          false
        );
        this.sendMessageStatus = true;
      } else {
        this.sendMessageStatus = false;
        $('#send-message-form .send-message button[type="submit"]').attr(
          "disabled",
          true
        );
      }
    }

    // card 415

    async events() {
      // send message events
      this.mainChat.initializeMessages();
      this.registerChatApi();
      $("#message-text-field").on("input change keydown", (e) => {
        let KeyID = e.keyCode;
        // card 415
        this.toggleChatSendMessageIcon();
        // end card 415
        // card 18
        if ($("#message-text-field").text().length > 700) {
          if (
            KeyID != 8 &&
            KeyID != 9 &&
            KeyID != 37 &&
            KeyID != 39 &&
            !(KeyID == 88 && e.ctrlKey)
          ) {
            e.preventDefault();
            return false;
          }
        }
        // end card 18
        // console.log("Key id",KeyID);
        if (KeyID != 8 && KeyID != 46) {
          this.sendTypingMessage(e);
        }
        $("#message_text_field").removeClass("is-invalid");
        if (KeyID == 9) {
          e.preventDefault();
          document.execCommand("insertHTML", false, "&nbsp;&nbsp&nbsp;&nbsp;");
          return;
        }
        if (e.which == 13 && e.shiftKey) {
          return;
        } else if (e.keyCode == 13) {
          e.preventDefault();
          if (this.sendMessageStatus) {
            this.sendMessage(e);
          }
        }
      });

      // sending images in the chat
      document
        .getElementById("message-text-field")
        .addEventListener("paste", async (event) => {
          try {
            event.preventDefault();
            console.log("pasting", event.clipboardData.items[0]);
            // card 18
            if (
              (
                $("#message-text-field").text() +
                event.clipboardData.getData("text/plain")
              ).length >= 700
            ) {
              return false;
            }
            // end card 18
            let file = event.clipboardData.items[0].getAsFile();

            file = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => resolve(reader.result);
              reader.onerror = (error) => reject(error);
            });

            let image = $("<img />", {
              src: file,
            });

            let image_remover = $("<span />", {
              class: "remove-icon",
              html: '<i class="fas fa-times"></i>',
            }).on("click", (e) => {
              e.stopPropagation();
              $(e.currentTarget).closest("div.image-container").remove();
              this.toggleChatSendMessageIcon();
            });

            $("#attachment-container").append(
              $("<div />", {
                class: "image-container",
                html: [image, image_remover],
              })
            );

            this.toggleChatSendMessageIcon();

            return false;
          } catch (error) {}
          let paste = (event.clipboardData || window.clipboardData).getData(
            "text"
          );
          console.log("What to paste", paste);
          // const selection = window.getSelection();
          // if (!selection.rangeCount) return false;
          // selection.deleteFromDocument();
          // selection
          //     .getRangeAt(0)
          //     .insertNode(this.nl2br(paste));
          document.execCommand(
            "insertHTML",
            false,
            this.nl2br(this.tabToSpace(this.spaceToNbsp(paste)))
          );
          event.preventDefault();
          // card 18
          this.toggleChatSendMessageIcon();
          // end card 18
        });

      $("#send-message-form").on("submit", (e) => this.sendMessage(e));

      // add someone in the chat by clicking add new button
      $("#chat-list-add-participant-btn").on("click", (e) =>
        this.showParticpantsToChat()
      );

      // add someone to chat by Search
      $("#search-new-particpant").on("change paste keyup focus", (e) =>
        this.addSomeoneToChatBySearch(e)
      );
      $("#search-new-particpant").on("focusout", (e) => {
        this.selectGroupChatOnFocusOutTimeout = setTimeout(() => {
          if (!this.selectedParticipantsToMessage.length) {
            this.showPublicChat(e);
          } else {
            let group_id = this.getGroupId(
              this.selectedParticipantsToMessage.map((el) => el)
            );
            if (group_id) {
              this.selectGroupChatById(group_id);
            } else {
              this.clearChat();
              this.selectedChatId = false;
            }
          }
        }, 250);
      });

      // add someone to selectedParticipantsToMessage
      $("#add-chat-participant-list").on("click", "li a.participant-item", (e) =>
        this.addParticipantToSelectedParticipantsToMessage(e)
      );

      // Remove someone from selectedParticipantsToMessage
      $("#chat-content-container").on(
        "click",
        "ul.chat-list-participant-group li div.chat-list-participant-item",
        (e) => this.removeFromSelectedParticipantsToMessage(e)
      );

      // card id 829
      $("#navClosePanel").on("click", () => {
        if ($("#myConvoPanel").hasClass("open")) {
          // closed
          CONV_STORAGE.closePanel();
          this.chatPanelStatus = "closed";
          this.selectedChatId = false;
          this.clearChat();
          this.clearSelectedGroupChatHTML();
          $("#search-new-particpant").val(""); // code 406
        }
      });
      // end card id 829

      $("#panelToggle").on("click", (e) => {
        if (!permissions.hasChat()) {
          return;
        }
        if (this.isRecordingOrLiveStream()) {
          return;
        }
        if ($("#myConvoPanel").hasClass("open")) {
          hideAll();
          // closed
          this.chatPanelStatus = "closed";
          this.selectedChatId = false;
          this.clearChat();
          this.clearSelectedGroupChatHTML();
          $("#search-new-particpant").val(""); // code 406

        } else {
          // opened
          if (this.toggleChatNotifications) {
            this.makeChatTabActive();
          }
          this.chatPanelStatus = "opened";
          if (this.lastSelectedChatId) {
            this.selectedChatId = this.lastSelectedChatId;
          }
          console.log("Groups", this.groups);
          console.log("Selected chat id", this.selectedChatId ,this.getPublicChat());
          if (!this.selectedChatId) {
            this.selectedChatId = this.getPublicChat()?.id;
            this.lastSelectedChatId = this.selectedChatId;
          }
          this.selectGroupChatById(this.selectedChatId);
          renderChatsList();
          this.scrollToBottom();
          // let group_id = this.getGroupId([])
          // this.selectGroupChatById(group_id)
          $("#message-text-field").trigger('focus'); // code 406
        }
        this.previousNotificationCountPanel = [];
        // this.toggleChatNotifications = 0;
        // let nootification_toggle_icon = $('#notification-count')
        // nootification_toggle_icon.attr('data-value', this.toggleChatNotifications)
        // nootification_toggle_icon.html(this.toggleChatNotifications)
      });
      //begin code card 599
      // $("#chat-nav-tab").on("click", (e) => {
      //     if (!$(this).hasClass("active")) {
      //         stopMediaPlayers($("#conversations-tab"));
      //     }

      //     setTimeout(() => {
      //         this.scrollToBottom();
      //     }, 100);
      // });
      //end code card 599
      $("#download-messages").on("click", (e) => this.downloadMessages(e));

      /**
       *      Notifications Events
       */
      // Remove event notification for button  Chats on the bottom left of the page
      $("#view-chats-btn").on("click", (e) => {
        this.closeAddParticipantList();
        this.checkUsersWithoutMessages(e);
        //     this.previousNotificationCount = []
        //     this.chatButtonNotifications = 0;
        //     this.toggleChatNotifications = 0;
        //     let nootification_toggle_icon = $('#notification-count')
        //     nootification_toggle_icon.attr('data-value', 0)
        //     nootification_toggle_icon.html(0)

        //     let group_button_toggle_notification_icon = $('#total-notification-count')
        //     group_button_toggle_notification_icon.attr('data-value', 0)
        //     group_button_toggle_notification_icon.html(0)
        this.toggleChatList();
      });

      $("#messagging-section .emoji-picker__wrapper").on(
        "keypress keydown",
        "button.emoji-picker__emoji",
        (e) => {
          if (e.keyCode == 13 || e.which == 13) {
          }
        }
      );

      // card 291
      // card id 829
      // Closing select someone to chat
      // uncomment to enable closing chat by clicking outside
    //   $(document).on("mousedown", (evt) => {
    //     this.closeChatSelection(evt);
    //     console.log("Is mouse over chat panel", CONV_STORAGE.mouseOverPanel);
    //     // console.log(CONV_STORAGE.panel.hasClass("open"));
    //     if (!CONV_STORAGE.mouseOverPanel && CONV_STORAGE.panel.hasClass("open")) {
    //       CONV_STORAGE.closePanel();
    //       this.chatPanelStatus = "closed";
    //       this.selectedChatId = false;
    //       this.clearChat();
    //       this.clearSelectedGroupChatHTML();
    //       $("#search-new-particpant").val(""); // code 406
    //     }
    //   });
      // end card id 829
      // end card 291

      // // selecting group chat to talk to from the dropdown
      $("#chat-groups-list").on("click", "a", async (e) => {
        this.selectGroupChat(e);
      });

      $("#chat-message-container").on("click", ".retry-message", (e) => {
        e.stopPropagation();
        this.retrySendMessage(e);
      });

      initAddParticipantMenuEvent();
      $("#chats-search-input").on("input", (e) => {
        debounceSearchChats();
      });
    }

    isRecordingOrLiveStream() {
      // console.log(`Checking recording ${localRecording.isRecording},Live stream ${live_stream.streamingStatus}`);
      if (
        localRecording.isRecording ||
        live_stream?.streamingStatus != "stopped"
      ) {
        return true;
      } else {
        return false;
      }
    }
    nl2br(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
    }
    tabToSpace(str) {
      return str.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
    }
    spaceToNbsp(str) {
      return str.replace(/ /g, "&nbsp;");
    }
    toggleChatList() {
      if (
        $("#chat-content-container .chat-groups .chat-list-container").hasClass(
          "active"
        )
      ) {
        $(
          "#chat-content-container .chat-groups .chat-list-container"
        ).removeClass("active");
        return false;
      }
      $("#chat-content-container .chat-groups .chat-list-container").addClass(
        "active"
      );
      // card 18
      this.updateDropdownChatList();
      // end card 18
    }
    closeChatList() {
      $("#chat-content-container .chat-groups .chat-list-container").removeClass(
        "active"
      );
    }
    openChatList() {
      $("#chat-content-container .chat-groups .chat-list-container").addClass(
        "active"
      );
    }

    generateString(length = 256) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
    addGroupNotification(group_id) {
      if (group_id == this.selectedChatId && this.chatPanelStatus == "opened") {
        this.scrollToBottom();
        return;
      }
      let group_index = false;
      this.groupNotifications.find((group, index) => {
        if (group.group_id == group_id) {
          group_index = index;
          return true;
        }
      });

      if (group_index === false) {
        // create group if doesnt exist
        this.groupNotifications.push({
          group_id: group_id,
          notifications: 0,
        });
        group_index = this.groupNotifications.length - 1;
      }
      if (!this.previousNotificationCount[group_id]) {
        this.previousNotificationCount[group_id] = 1;
      } else {
        this.previousNotificationCount[group_id] += 1;
      }
      if (!this.previousNotificationCountPanel[group_id]) {
        this.previousNotificationCountPanel[group_id] = 1;
      } else {
        this.previousNotificationCountPanel[group_id] += 1;
      }
      // initiate if it doesnt exist
      this.groupNotifications[group_index]["notifications"] += 1;

      let group_element = $("#chat-groups-list").find(
        `a.dropdown-item[data-group="${group_id}"] span.notification-icon`
      );
      group_element.attr(
        "data-value",
        this.groupNotifications[group_index]["notifications"]
      );
      group_element.html(this.groupNotifications[group_index]["notifications"]);
      updateChatBadge(group_id, this.groupNotifications.find((g) => g.group_id == group_id)?.notifications ?? 0);
      // adding notification count on group chat
      if (
        this.previousNotificationCountPanel[group_id] == 1
        // && this.chatPanelStatus == "closed"
      ) {
        this.toggleChatNotifications++;
        let toggle_notification_element = $("#notification-count");
        toggle_notification_element.attr(
          "data-value",
          this.toggleChatNotifications
        );
        toggle_notification_element.html(this.toggleChatNotifications);
      }
      if (this.previousNotificationCount[group_id] == 1) {
        this.chatButtonNotifications++;
        let total_notification_count_element = $("#total-notification-count");
        total_notification_count_element.attr(
          "data-value",
          this.chatButtonNotifications
        );
        total_notification_count_element.html(this.chatButtonNotifications);
      }

      //this.notificationSound.play()
      Video.sounds.play("newChatMessage");
    }
    readMessagesbyGroupId(group_id) {
      let group_index = false;
      this.groupNotifications.find((group, index) => {
        if (group.group_id == group_id) {
          group_index = index;
          return true;
        }
      });
      if (group_index === false) {
        // create group if doesnt exist
        this.groupNotifications.push({
          group_id: group_id,
          notifications: 0,
        });
        group_index = this.groupNotifications.length - 1;
      }

      if (
        this.groupNotifications[group_index] &&
        this.groupNotifications[group_index]["notifications"] &&
        this.chatButtonNotifications > 0
      ) {
        // this.chatButtonNotifications = this.chatButtonNotifications - this.groupNotifications[group_id].notifications;
        // this.toggleChatNotifications = this.toggleChatNotifications1ons;
        this.chatButtonNotifications = this.chatButtonNotifications - 1;

        if (this.toggleChatNotifications > 0) {
          // this.toggleChatNotifications = this.toggleChatNotifications = 0;
          this.toggleChatNotifications = this.chatButtonNotifications;
        }
        let total_notification_count_element = $("#total-notification-count");
        total_notification_count_element.attr(
          "data-value",
          this.chatButtonNotifications
        );
        total_notification_count_element.html(this.chatButtonNotifications);
        let toggle_notification_element = $("#notification-count");
        toggle_notification_element.attr(
          "data-value",
          this.toggleChatNotifications
        );
        toggle_notification_element.html(this.toggleChatNotifications);
      }
      this.groupNotifications[group_index]["notifications"] = 0;
      updateChatBadge(group_id, 0);
      this.previousNotificationCountPanel[group_id] = 0;
      this.previousNotificationCount[group_id] = 0;
      let group_element = $("#chat-groups-list").find(
        `a.dropdown-item[data-group="${group_id}"] span.notification-icon`
      );
      $(
        `.toolbar-bottom .chatBubbleContainer .chatBubbleMessageIcon[data-chat-id="${group_id}"] .chatBubbleNotificationNumber`
      ).empty();
      $(
        `.toolbar-bottom .chatBubbleContainer .chatBubbleMessageIcon[data-chat-id="${group_id}"] ~ .chatBubblesMessageContainer`
      ).removeClass("showChatMessageContainer");
      $(
        `.toolbar-bottom .chatBubbleContainer .chatBubbleMessageIcon[data-chat-id="${group_id}"]`
      )
        .closest(".videoViewContainer")
        .removeClass("message-req");
      setTimeout(() => {
        $(
          `.toolbar-bottom .chatBubbleContainer .chatBubbleMessageIcon[data-chat-id="${group_id}"]`
        )
          .closest(".videoViewContainer")
          .removeClass("message-shown");
      }, 500);
      group_element.attr("data-value", 0);
      group_element.html(0);
    }

    /***
     *
     *          DATABASE TRANSACTIONS
     *
     */

    async initChatPublicGroup() {
      this.creatingGroupStatus = true;
      await this.createGroup([], true)
        .then((res) => {
          this.createLocalGroup(res.data);
          group_id = res.data.id;
          this.selectedChatId = group_id;
          this.lastSelectedChatId = this.selectedChatId;
        })
        .catch((err) => {})
        .finally(() => {
          this.creatingGroupStatus = false;
          // clearInterval(checking_group_timeout)
        });
    }

    async loadGroupsAndMessages() {
      await axios
        .get(
          convertPath(
            `/chat/kino/${room.getName()}/groups?uniqueID=${this.myUniqueId}`
          ),
          await electronConfig()
        )
        .then(async (res) => {
          if (!res.data.length) {
            await this.initChatPublicGroup();
            return;
          }
          if (res.data) {
            await Promise.all(
              res.data.map(async (el) => {
                await this.createLocalGroup(el);
                if (this.getGroupChatById(el.id) != false) {
                  this.decryptGroupMessages(el.id, el.messages);
                }
              })
            );
          }
          // check if I am in the group
        })
        .catch((err) => {
          console.error("chat", err);
        });
      renderChatsList();
      this.selectedChatId = false;
    }

    async createGroup(participants = [], override = false) {
      let pps = [];
      if (override) {
        pps = participants;
      } else {
        pps = this.selectedParticipantsToMessage.map((p) => {
          return {
            guest_id: p,
            displayName: this.getParticipantDisplayName(p),
          };
        });
      }

      //checking if it is not public chat
      if (pps.length && !pps.find((p) => p.guest_id == this.myUniqueId)) {
            pps.push({
            guest_id: this.myUniqueId,
            displayName: MY_NAME,
            });
      }
      let response = await axios.post(
        convertPath(`/chat/group`),
        {
          kino_id: room.getName(),
          participants: pps,
          read_by: [this.myUniqueId],
          is_public: pps.length ? false : true,
        },
        await electronConfig()
      );

      try {
        if (response.data.enc_key) {
          this.storeEncryptionKey(response.data.id, response.data.enc_key);
        }
      } catch (error) {
        console.error("chat_Error", error);
      }

      return response;
    }

    addGroupMembers(group_id,participants = []) {
        return new Promise(async (resolve, reject) => {
            axios.post(
                convertPath(`/chat/group/add-members`),
                {
                  kino_id: room.getName(),
                  participants: participants,
                  guest_id: this.myUniqueId,
                  group_id: group_id,
                },
                await electronConfig()
              ).then((res) => {
                resolve(res.data);
              }).catch((err) => {
                reject(err);
              });
        })
      }

    // card 120
    nameChanged(userId, displayName) {
      $(
        `#chat-groups-list a[data-participant="${this.getParticipantGuestId(
          userId
        )}"] .profile-img`
      ).html(
        this.getUserButton(sanitizeHtml(displayName, this.sanitizeNoOptions))
      );
      $(
        `#chat-groups-list a[data-participant="${this.getParticipantGuestId(
          userId
        )}"] .chat-name`
      ).text(sanitizeHtml(displayName, this.sanitizeNoOptions));
      $(
        `#add-chat-participant-list a[data-id="${this.getParticipantGuestId(
          userId
        )}"] .profile-img`
      ).html(
        this.getUserButton(sanitizeHtml(displayName, this.sanitizeNoOptions))
      );
      $(
        `#add-chat-participant-list a[data-id="${this.getParticipantGuestId(
          userId
        )}"] .profile-desc .full-name span`
      ).text(sanitizeHtml(displayName, this.sanitizeNoOptions));
      this.selectGroupChatById(this.selectedChatId);
    }
    // end card 120

    async sleep(time) {
      return await new Promise((r) => setTimeout(r, time));
    }

    async getDecryptedText(group_id, encrypted_text) {
      return await new Promise(async (resolve, reject) => {
        let dec_keys = localStorage.getItem("encs");
        if (dec_keys) {
          dec_keys = JSON.parse(dec_keys);
          let dec_key = dec_keys.find((enc) => group_id == enc.group);
          if (dec_key) dec_key = dec_key.enc;
          let decrypted_text = "";
          try {
            decrypted_text = CryptoJS.AES.decrypt(
              encrypted_text,
              dec_key
            ).toString(CryptoJS.enc.Utf8);
            if (decrypted_text == "") {
              decrypted_text = encrypted_text; //card 775
            }
          } catch (error) {
            decrypted_text = encrypted_text; //card 775
          }
          resolve(decrypted_text);
        } else {
          await this.sleep(2000);
          resolve(await this.getDecryptedText(group_id, encrypted_text));
        }
      });
    }

    decryptString(decryption_key, encrypted_text) {
      try {
        let decrypted_text = "";
        decrypted_text = CryptoJS.AES.decrypt(
          encrypted_text,
          decryption_key
        ).toString(CryptoJS.enc.Utf8);
        if (decrypted_text == "" || decrypted_text === encrypted_text) {
          decrypted_text =
            "<span class='italic-disabled'>Unable to load message</span>";
        }
        return decrypted_text;
      } catch (error) {
        return encrypted_text;
      }
    }

    encryptString(encryption_key, decrypted_text) {
      try {
        return decrypted_text.length > 0
          ? CryptoJS.AES.encrypt(decrypted_text, encryption_key).toString()
          : "";
      } catch (error) {
        return decrypted_text;
      }
    }

    storeGroupMessage(group_id, message) {
      if (this.messages[group_id]) {
        this.messages[group_id].push(message);
      } else {
        this.messages[group_id] = [message];
      }
    }

    getDecryptionKey(groupId) {
      let encs = [];

      if (localStorage.getItem("encs")) {
        encs = JSON.parse(localStorage.getItem("encs"));
        if (encs && encs.length) {
          let group = encs.find((gr) => gr.group == groupId);
          if (group) {
            return group.enc;
          }
        }
      }
      return false;
    }

    updateLocalGroupMembers(group_id, members) {
        let group = this.getGroupChatById(group_id);
        if (group) {
            group.members = members;
        }
    }
    // Create a local group and add to HTML using group id
    async createLocalGroup(group, notify = false) {
      await axios
        .get(
          convertPath(
            `/chat/kino/${room.getName()}/participants?uniqueID=${
              this.myUniqueId
            }`
          ),
          await electronConfig()
        )
        .then((res) => {
          this.participantNames = res.data;
        })
        .catch((err) => {});

      // check if this message is meant for me or I sent it
      if (group.members.length) {
        if (
          !group.members.some(
            (pp) =>
              pp.guest_id == this.myUniqueId ||
              (USER_ID > 0 && pp.user_id == USER_ID)
          )
        )
          return;
      }
      let group_participants = group.members.filter(
        (pp) =>
          pp.guest_id != this.myUniqueId &&
          (USER_ID == 0 || pp.user_id != USER_ID)
      );

      this.groups.push({
        id: group.id,
        kino_id: group.kino_id,
        members: group.members,
        is_public: group.is_public,
        read_by: group.read_by,
        created_at: group.created_at,
      });

      this.groupNotifications.push({
        group_id: group.id,
        notifications: 0,
      });

      renderChatsList();
      // let participants_list = this.getParticipantIds().filter(pId => {
      //     return (this.getParticipantDisplayName(pId).toLowerCase().search($('#search-new-particpant').val().toLowerCase()) > -1 )
      // })

      try {
        // card 120
        if (group_participants.length != 1) {
          $("#chat-groups-list").append(`<a class="dropdown-item" data-group="${
            group.id
          }" href="">

                          <div class="profile-img">
                              ${
                                group_participants.length
                                  ? this.getUserButton(
                                      sanitizeHtml(
                                        group_participants
                                          .map((el) => {
                                            return sanitizeHtml(
                                              this.getParticipantDisplayName(
                                                el.guest_id
                                              ),
                                              this.sanitizeNoOptions
                                            );
                                          })
                                          .join(", "),
                                        this.sanitizeNoOptions
                                      )
                                    )
                                  : this.getUserButton("Public Chat")
                              }
                          </div>
                          <div class="name-notifications">
                              <div class="chat-name">
                                  ${
                                    group_participants.length
                                      ? group_participants
                                          .map((el) => {
                                            return `${sanitizeHtml(
                                              this.getParticipantDisplayName(
                                                el.guest_id
                                              ),
                                              this.sanitizeNoOptions
                                            )}`;
                                          })
                                          .join(", ")
                                      : "Public Chat"
                                  }
                              </div>
                              <span class="notification-icon" data-value="0">0</span>
                          </div>
                  </a>`);
          // end card 120
        } else {
          // checking if group is already added in HTML
          if (
            $(
              `#chat-groups-list a[data-participant="${group_participants[0].guest_id}"]`
            ).length
          ) {
            $(
              `#chat-groups-list a[data-participant="${group_participants[0].guest_id}"]`
            ).attr("data-group", group.id);
          } else {
            $("#chat-groups-list").append(`<a class="dropdown-item" data-group="${
              group.id
            }" data-participant="${
              group_participants[0] ? group_participants[0].guest_id : ""
            }" href="">

                          <div class="profile-img">
                              ${this.getUserButton(
                                sanitizeHtml(
                                  this.getParticipantDisplayName(
                                    group_participants[0].guest_id
                                  ),
                                  this.sanitizeNoOptions
                                )
                              )}
                          </div>
                          <div class="name-notifications">
                              <div class="chat-name">${sanitizeHtml(
                                this.getParticipantDisplayName(
                                  group_participants[0].guest_id
                                ),
                                this.sanitizeNoOptions
                              )}</div>
                              <span class="notification-icon" data-value="0">0</span>
                          </div>
                      </a>`);
          }
        }
      } catch (error) {
        console.error("chat", error);
      }
    }

    getPublicChat() {
      return this.groups.find((group) => group.is_public);
    }
    // Finding groupId
    getGroupId(_participants) {
      _participants.push(this.myUniqueId);
      let groups = this.groups.filter((group) => {
        if (_participants.length == 1 && group.members.length == 0) return true; // geting public chat
        if (
          _participants.length == group.members.length &&
          group.members.every(
            (pp) =>
              _participants.includes(pp["guest_id"]) ||
              (USER_ID > 0 && pp["user_id"] == USER_ID)
          )
        )
          return true;
      });
      if (groups.length) return groups[0].id;
      return false;
    }

    getGroupChatById(group_id) {
      return this.groups.find((group) => group.id == group_id);
    }

    downloadMessageButton() {
      let messages = [];
      let hasMessages = false;
      if (this.selectedChatId) {
        messages = this.messages[this.selectedChatId];
        hasMessages = messages?.length > 0;
      }
      if (hasMessages) {
        $("#download-messages").attr("disabled", false);
        $("#download-messages").attr("title", "Download");
      } else {
        $("#download-messages").attr("disabled", true);
        $("#download-messages").attr("title", "No chat messages to download");
      }
    }

    getGroupName(group_participants) {
      if (group_participants.length) {
        return group_participants
          .filter(
            (pp) =>
              pp.guest_id != this.myUniqueId &&
              (USER_ID == 0 || pp.user_id != USER_ID)
          )
          .map((pp) => {
            return pp.displayName;
          })
          .join(", ");
      } else {
        return "Public";
      }
    }

    downloadMessages(e) {
      if (e) {
        e.stopPropagation();
      }
      let messages = [];
      let file_name = "";
      if (this.selectedChatId) {
        messages = this.messages[this.selectedChatId];
        let group_participants = [];
        if (messages?.length) {
          group_participants = this.groups.find(
            (group) => group.id == messages[0].group_id
          ).members;
          if (group_participants.length) {
            file_name = group_participants
              .filter(
                (pp) =>
                  pp.guest_id != this.myUniqueId &&
                  (USER_ID == 0 || pp.user_id != USER_ID)
              )
              .map((pp) => {
                return pp.displayName;
              })
              .join(" - ");
          } else {
            file_name = "Public Chat";
          }
        } else {
          file_name = "";
        }
        if (messages) {
          messages = messages.map((message) => {
            return `[${moment(message.created_at).format("M/D/yyyy h:mm A")}] ${
              message.sender == this.myUniqueId
                ? `${message.sender_name} (me): ${sanitizeHtml(
                    message.message,
                    this.sanitizeNoOptions
                  )}\r\n`
                : `${message.sender_name}: ${sanitizeHtml(
                    message.message,
                    this.sanitizeNoOptions
                  )}\r\n`
            }`;
          });
        }
      }
      if (!file_name.length) {
        return false;
      }
      // card 18
      $("#download-messages").attr("disabled", true);
      download(
        new Blob(messages, { type: "text/plain;charset=utf-8" }),
        file_name,
        "text/plain"
      );
      setTimeout(() => {
        $("#download-messages").attr("disabled", false);
      }, 2000);
      // end card 18
      return false;
    }

    async init() {
      //uniqueid is GUEST_ID
      $("#myConvoPanel").removeClass("d-none")
      this.myUniqueId =
        typeof GUEST_ID != "undefined"
          ? GUEST_ID
          : room.getLocalParticipantProperty("guest_id"); //bb
      if (permissions.hasChat()) {
        axios
          .get(
            convertPath(`/chat/kino/${room.getName()}/participants`),
            await electronConfig()
          )
          .then((res) => {
            this.participantNames = res.data;
          })
          .catch((err) => {});

        this.participantNames.push({
          guest_id: this.myUniqueId,
          displayName: MY_NAME,
          user_id: USER_ID,
        });

        // this.loadAllUserNamesInChatList()

        // get messages from other users
        this.loadGroupsAndMessages();
        // console.log("chat_participants", room.getParticipants());
      }
    }

    async getChatEncryptionKey(group_id) {
      try {
        //try to get the key from local storage if it's used before
        const localKey = this.getLocalEncKeyV2(group_id);
        if (localKey) return localKey;
        //try to get the key from the server
        const enc_key = await axios
          .get(
            convertPath(
              `/chat/keys/get/${room.getName()}/${group_id}/${GUEST_ID}`
            ),
            await electronConfig()
          )
          .then((res) => {
            return res.data.key;
          })
          .catch((err) => null);
        console.log("chat_encryption_key", enc_key);
        //store the key in local storage
        if (enc_key) this.storeEncryptionKey(group_id, enc_key);

        //probably the chat has an old key, so we will get the old key from local storage
        if (!enc_key) {
          const oldKey = this.getDecryptionKey(group_id);
          return oldKey;
        }
        return enc_key;
      } catch (error) {
        console.error("chat_encryption_key", error);
        return null;
      }
    }

    storeEncryptionKey(group_id, enc_key) {
      let encs = [];
      if (localStorage.getItem("encs_v2"))
        encs = JSON.parse(localStorage.getItem("encs_v2"));
      if (!encs.find((gr) => gr.group_id == group_id)) {
        // group key doesn't exist in the local storage
        let new_encryption = {
          group_id: group_id,
          enc: enc_key,
          created_at: new Date().getTime(),
        };
        encs.push(new_encryption);
        // end sending the key to the other users;
        localStorage.setItem("encs_v2", JSON.stringify(encs));
        return true;
      }
      return false;
    }

    getLocalEncKeyV2(group_id) {
      let encs = [];

      if (localStorage.getItem("encs_v2")) {
        encs = JSON.parse(localStorage.getItem("encs_v2"));
        if (encs && encs.length) {
          let group = encs.find((gr) => gr.group_id == group_id);
          if (group) {
            return group.enc;
          }
        }
      }
      return false;
    }

    // card 451
    decryptCurrentMessages() {
      this.encryptedMessages.forEach(async (encrypted_message, index) => {
        let decryption_key = this.getDecryptionKey(encrypted_message.group_id);
        if (decryption_key) {
          let message = encrypted_message;

          let decrypted_text = await this.getDecryptedText(
            message.group_id,
            message.message
          )
            .then((res) => res)
            .catch((err) => err);
          message.message = decrypted_text ? decrypted_text : "";

          //begin card 755
          if (message.images) {
            message.images = await Promise.all(
              message.images.map(async (image) => {
                // return await axios.get(api.global.app_url+image).then(async (res) => {//uncomment on electron
                return await axios
                  .get(`${isElectron ? api.global.app_url + image : image}`)
                  .then(async (res) => {
                    //comment on electron
                    return await this.getDecryptedText(
                      message.group_id,
                      res.data
                    ).then((res) => res);
                  })
                  .catch((err) => err);
              })
            );
          } else {
            message.images = [];
          }
          //end card 755

          this.messages.push(message);
          delete this.encryptedMessages[index];
        }
      });
    }

    async decryptGroupMessages(group_id, encrypted_messages) {
      // let decryption_key = this.getDecryptionKey(
      //     encrypted_message.group_id
      // );
      const server_decryption_key = await this.getChatEncryptionKey(group_id);
      const decryption_key = server_decryption_key
        ? server_decryption_key
        : this.getDecryptionKey(group_id);
      for (let index = 0; index < encrypted_messages.length; index++) {
        // const encrypted_message = encrypted_messages[index];
        const message = encrypted_messages[index];
        if (decryption_key) {
          let decrypted_text = this.decryptString(
            decryption_key,
            message.message
          );
          message.message = decrypted_text ? decrypted_text : "";

          //begin card 755
          if (message.images) {
            message.images = await this.decryptImages(
              decryption_key,
              message.images
            );
          } else {
            message.images = [];
          }
          //end card 755
        }

        this.storeGroupMessage(group_id, message);
      }
    }

    async decryptImages(decryption_key, images) {
      return await Promise.all(
        images.map(async (image) => {
          // return await axios.get(api.global.app_url+image).then(async (res) => {//uncomment on electron
          return await axios
            .get(`${isElectron ? api.global.app_url + image : image}`)
            .then(async (res) => {
              //comment on electron
              return this.decryptString(decryption_key, res.data).then(
                (res) => res
              );
            })
            .catch((err) => err);
        })
      );
    }

    // end card 451

    guestIdPropertyChanged(user) {
      setTimeout(() => {
        // prevent adding dublicates
        this.addToParticipantDisplayNames(
          user.getProperty("guest_id"),
          user.getDisplayName(),
          user.getProperty("user_id")
        );
      }, 1500);
    }

    // when a user connects on KINO
    userConnected(user) {
      // Do nothing
    }

    checkUsersWithoutMessages(e) {
      $("#chat-groups-list a[data-participant]:not(a[data-group])").each(
        (index, el) => {
          let participant_id = this.getParticipantParticipantId(
            $(el).data("participant")
          );

          /*Begin code card ID: 412 */
          if (!participant_id) el.remove();
          else if (
            Video.videos[participant_id] &&
            Video.videos[participant_id].disconnectTimer > 0
          )
            el.remove();
          /*End code card ID: 412 */
        }
      );
    }

    // GET PARTICIPANTS DOESNT INCLUDE HIMSELF
    getParticipantGuestId(participant_id) {
      return room.getParticipantById(participant_id)
        ? room.getParticipantById(participant_id).getProperty("guest_id")
        : null;
    }
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
    getParticipantIds() {
      return [
        ...new Set(
          this.participantNames
            .filter(
              (user) =>
                user.guestId != this.myUniqueId &&
                (USER_ID == 0 || user?.user_id != USER_ID)
            )
            .map((user) => user.guestId)
        ),
      ];
    }

    participantHasChat(guest_id) {
      try {
        if (!permissions.isWorkspace) {
          return true;
        }
        const participant = room
          .getParticipants()
          .find((p) => p.getProperty("guest_id") == guest_id);
        if (participant && participant.getProperty("has_chat")) {
          return true;
        }
        return false;
      } catch (error) {
        return !permissions.isWorkspace;
      }
    }

    /**
     *      Participant Display Names
     *
     */
    async addToParticipantDisplayNames(guest_id, displayName, user_id = 0) {
      // if (this.participantNames.some((pp) => pp)) return false;
      // await axios.get(convertPath(`/chat/kino/${room.getName()}/participants`), await electronConfig())
      // .then((res) => {
      //         this.participantNames = res.data;
      //     }).catch((err) => {});
      const exists = this.participantNames.find(
        (p) => p.guestId === guest_id && p.user_id == (user_id ?? 0)
      );
      if (!exists) {
        this.participantNames.push({
          guestId: guest_id,
          displayName: displayName,
          user_id: user_id,
          joined: "joined",
        });
      }
      // console.trace("participantNames", this.participantNames)
      renderChatsList();
    }

    getParticipantDisplayName(pId) {
      let pname = room
        .getParticipants()
        .find((p) => p.getProperty("guest_id") == pId)?._displayName;
      if (!pname) {
        // there is a mix in participant display names guestId with guest_id
        pname = this.participantNames
          .filter((pp) => pp.guestId == pId || pp.guest_id == pId)
          .map((pp) => pp.displayName);
        return pname.length ? pname[pname.length - 1] : "Kino Guest";
      }
      return pname;
    }
    getParticipantParticipantId(pId) {
      let participant = room
        .getParticipants()
        .find((p) => p.getProperty("guest_id") == pId);
      if (participant) {
        return participant.getId();
      }
      return false;
    }

    isParticipantOnline(pId) {
        const p = room
        .getParticipants()
        .find((p) => p.getProperty("guest_id") == pId);
        return p? true : false;
    }

    // Showing participants to chat on input name box and add new button
    showParticpantsToChat() {
      this.closeChatList();
      $("#add-chat-participant-list").empty();

      if (!this.getParticipantIds().length && this.groups.length == 1) {
        this.openAddParticipantList();
        $("#add-chat-participant-list").append(`
                  <li class="list-item">
                      <a class="participant-item empty"><span>There are no other users in this Kino.</span></a>
                  </li>
              `);
        return;
      }

      this.openAddParticipantList();
      let participants = this.getParticipantIds().filter((pId) => {
        return (
          this.getParticipantDisplayName(pId)
            .toLowerCase()
            .search($("#search-new-particpant").val().toLowerCase()) > -1
        );
      });
      // console.log("getParticipantIds", this.getParticipantIds())
      // console.log("participants", participants)

      // check is already added
      let left_participants = participants
        .filter((pId) => !this.selectedParticipantsToMessage.includes(pId))
        .map((pId) => {
          this.addParticpiantInGroupChatHTML(
            pId,
            this.getParticipantDisplayName(pId)
          );
          return pId;
        });

      if (!left_participants.length) {
        $("#add-chat-participant-list").append(`
                  <li class="list-item">
                      <a class="participant-item empty"><span>All participants have been added</span></a>
                  </li>
              `);
      }
    }

    groupUniqueParticipants() {
      const chatUsers = this.getChatsListArray();
      const participants = [
        ...new Set(
          this.participantNames.filter(
            (user) =>
              user.guestId != this.myUniqueId &&
              (USER_ID == 0 || user?.user_id != USER_ID)
          )
        ),
      ].filter((pp) => !chatUsers.find((pps) => pps.pId === (pp.guestId ?? pp.guest_id)));

      const nonSignedIn = participants.filter((pp) => pp.user_id == 0);
      console.log("nonSignedIn", nonSignedIn);
      const signedIn = participants.filter((pp) => pp.user_id > 0);
      console.log("signedIn", signedIn);
      const groupedUsers = signedIn.reduce((acc, cur) => {
        acc[cur.user_id] = cur;
        return acc;
      }, {});
      console.log("groupedUsers", groupedUsers);
      const uniqueParticipants = Object.values(groupedUsers).concat(nonSignedIn);
      console.log("uniqueParticipants", uniqueParticipants);
      return uniqueParticipants.map((pp) => pp.guestId ?? pp.guest_id);
    }

    // automatic searching while typing
    addSomeoneToChatBySearch(e) {
      // this.clearChat()
      this.hidePublicChat();
      // card 473
      this.closeAddParticipantList();
      //end card 473
      // this.selectedChatId = false;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.openChatList();

      this.searchTimeout = setTimeout(() => {
        $("#chat-groups-list").empty();
        const participants = this.getChatsListArray();
        this.groupUniqueParticipants().forEach((el) => {
          participants.push({
            pId: el,
            group: null,
            name: this.getParticipantDisplayName(el),
            isChat: false,
          });
        });
        let found_items = participants.filter(
          (pp) =>
            pp.name
              .toLowerCase()
              .search($("#search-new-particpant").val().toLowerCase()) > -1
        );

        if (found_items.length) {
          found_items.forEach((found_item) => {
            this.appendChatToList(found_item);
          });
        } else {
          $("#chat-groups-list").append(`
                      <li class="list-item no-found">
                          <a class="participant-item"><span>No matches found</span></a>
                      </li>
                  `);
        }
      }, 150);
    }

    // card 18
    updateDropdownChatList() {
      this.openChatList();
      $("#chat-groups-list").empty();

      const participants = this.getChatsListArray();

      this.groupUniqueParticipants().forEach((el) => {
        participants.push({
          pId: el,
          group: null,
          name: this.getParticipantDisplayName(el),
          isChat: false,
        });
      });

      // perform search
      let found_items = participants.filter(
        (pp) =>
          pp.name
            .toLowerCase()
            .search($("#search-new-particpant").val().toLowerCase()) > -1
      );

      if (found_items.length) {
        found_items.forEach((found_item) => {
          this.appendChatToList(found_item);
        });
      } else {
        $("#chat-groups-list").append(`
                  <li class="list-item no-found">
                      <a class="participant-item"><span>No matches found</span></a>
                  </li>
              `);
      }
    }

    getChatLastMessage(group_id) {
        if (!this.messages[group_id]) {
            return null;
        }
        return this.messages[group_id][this.messages[group_id].length - 1]?.message.slice(0, 20);
    }
    getChatsListArray() {
      console.log("groups", this.groups);
      const participants = this.groups.map((group) => {
        const unread = this.groupNotifications.find((g) => g.group_id == group?.id)?.notifications ?? 0;
        if (!group.members.length)
          return {
            pId: null,
            group: group.id,
            name: "Public Chat",
            members: [],
            isChat: true,
            lastMessage: this.getChatLastMessage(group.id) ?? 'No messages',
            isOnline: false,
            unread: unread
          };

        if (group.members.length == 2) {
          let member = group.members.find(
            (pp) =>
              pp.guest_id != this.myUniqueId &&
              (USER_ID == 0 || pp.user_id != USER_ID)
          );
          if(!member){
            member = group.members.find(
                (pp) =>
                  pp.guest_id != this.myUniqueId
              );
          }

          if(member){
              return {
                pId: member?.guest_id,
                group: group.id,
                name: member.displayName,
                members: group.members,
                isChat: true,
                lastMessage: this.getChatLastMessage(group.id) ?? 'No messages',
                isOnline: this.isParticipantOnline(member?.guest_id),
                unread: unread
              };
          }
        }

        return {
          pId: null,
          group: group.id,
          name: group.members
            .filter(
              (participant) =>
                participant.guest_id != this.myUniqueId &&
                (USER_ID == 0 || participant.user_id != USER_ID)
            )
            .map((participant) => participant.displayName)
            .join(", "),
          members: group.members,
          isChat: true,
          lastMessage: this.getChatLastMessage(group.id) ?? 'No messages',
          isOnline: false,
          unread: unread
        };
      });

      return participants;
    }

    appendChatToList(found_item) {
      const notifications =
        this.groupNotifications.find((not) => not.group_id == found_item?.group)
          ?.notifications ?? 0;
      $("#chat-groups-list").append(`<a class="dropdown-item" ${
        found_item.pId ? `data-participant="${found_item.pId}"` : ""
      } ${found_item.group ? `data-group="${found_item.group}"` : ""}  href="">
              <div class="profile-img">
                  <div class="user-icon" title="" data-toggle="tooltip" data-placement="top" data-original-title="${sanitizeHtml(
                    found_item.name,
                    this.sanitizeNoOptions
                  )}">${this.profileImgUser}</div>
              </div>
              <div class="name-notifications">
                  <div class="chat-name">${sanitizeHtml(
                    found_item.name,
                    this.sanitizeNoOptions
                  )}</div>
                  ${
                    notifications > 0 || !found_item.isChat
                      ? `<span class="notification-icon" data-value="${notifications}">
                      ${notifications}
                  </span>`
                      : `
                      <span><i class='far fa-comments' style='font-size:16px;color:#6c757d'></i></span>
                  `
                  }
              </div>
          </a>`);
    }

    hidePublicChat() {
      if (
        !$(
          "#chat-content-container .chat-list-participant-group li.pub-chat"
        ).hasClass("d-none")
      ) {
        this.selectedChatId = false;
        this.clearChat();
        $(
          "#chat-content-container .chat-list-participant-group li.pub-chat"
        ).addClass("d-none");
      }
    }

    showPublicChat(e) {
      if (!this.selectedParticipantsToMessage.length) {
        let group_id = this.getGroupId([]);
        this.selectGroupChatById(group_id);
        $("#search-new-particpant").val("");
      }
    }

    // when we click a participant on the serch or button open
    addParticipantToSelectedParticipantsToMessage(e) {
      // this.selectedParticipantsToMessage.forEach(el => {
      // })

      e.preventDefault();
      let pId = $(e.currentTarget).data("id");
      if (!pId) return;
      $(e.currentTarget).parent().remove();

      // finding someone in chat list to bypass HTML issues in case user changes HTML
      this.selectedChatId = false;
      this.addToSelectedParticipantToMessageById(pId);
      this.downloadMessageButton();
      e.stopPropagation();
      this.showParticpantsToChat();
    }

    selectChatUsingParticipantId(participantId) {
      if (!room.getParticipantById(participantId)) return;
      let guest_id = room
        .getParticipantById(participantId)
        .getProperty("guest_id");
      this.clearChat();
      this.clearSelectedGroupChatHTML();
      this.selectedChatId = false;
      this.selectedParticipantsToMessage = [];
      this.addToSelectedParticipantToMessageById(guest_id);
    }

    addToSelectedParticipantToMessageById(pId) {
      pId = this.getParticipantIds().filter((pp) => pp == pId);
      if (!pId.length) return;

      this.selectedParticipantsToMessage.push(pId[0]);
      this.addToSelectedParticipantToMessageHTML(
        pId,
        this.getParticipantDisplayName(pId)
      );
      let group_id = this.getGroupId(
        this.selectedParticipantsToMessage.map((el) => el)
      );
      this.selectedParticipantsToMessage.forEach((el) => {});
      if (group_id) this.selectGroupChatById(group_id, false);
    }

    removeFromSelectedParticipantsToMessage(e) {
      e.stopPropagation(); // card 291
      let element = $(e.currentTarget).closest("li");
      let pId = element.data("id");
      if (!pId) return;
      this.selectedParticipantsToMessage =
        this.selectedParticipantsToMessage.filter(
          (pp) => pp != pId && pp != this.myUniqueId
        );
      element.remove();
      // card 120
      let userListLength = $(
        `.chat-list-participants .chat-list-participant-group li.d-none:not(.pub-chat)`
      ).length;
      if (userListLength > 0)
        $(
          `.chat-list-participants .chat-list-participant-group li.d-none:not(.pub-chat)`
        )
          .eq(userListLength - 1)
          .removeClass("d-none");
      // end card 120
      this.clearChat();

      let group_id = this.getGroupId(
        this.selectedParticipantsToMessage.map((el) => el)
      );
      if (group_id) this.selectGroupChatById(group_id, false);

      // card 359
      this.downloadMessageButton();
      // end card 359
    }

    /*************************
     *
     *      GROUP FUNCTIONS
     *
     */
    async sendMessage(e) {
      e.preventDefault();
      let message_text = $("#message-text-field").html();
      // message_text = message_text.replace()
      if (!message_text.length && !$("#attachment-container").find("img").length)
        return;
      console.log("Message text before sanitize", message_text);
      let images = $("#attachment-container").find("img");
      message_text = sanitizeHtml(message_text, {
        allowedTags: ["span", "br"],
        allowedAttributes: {
          span: ["class"],
          img: ["src"],
        },
        allowedSchemesByTag: {
          img: ["data"],
        },
      });
      console.log("Message text after sanitize", message_text);
      let message_images = images
        .map((index, el) => el.getAttribute("src"))
        .toArray();

      // check if message is all spaces and there is no pictures

      let space_message = message_text;
      space_message = space_message.replace(/\s/g, "");
      if (space_message.length == 0 && message_images.length == 0) {
        return false;
      }

      message_text = message_text.trim();

      $("#message-text-field").html("");
      $("#attachment-container").html("");
      // card 415
      this.toggleChatSendMessageIcon();

      // // create a group to chat with
      let group_id = this.selectedChatId
      //End code card ID: 18
      this.addMessageToHTML({
        user_id: this.myUniqueId,
        sender_user_id: USER_ID,
        sender_name: MY_NAME,
        message: message_text,
        images: message_images,
        date: new Date(),
        read_by: [this.myUniqueId],
        group_id: group_id,
      });
      this.scrollToBottom();

      this.messageQueue.push({
        user_id: this.myUniqueId,
        sender_name: MY_NAME,
        sender_user_id: USER_ID,
        message: message_text,
        images: message_images,
        date: moment(),
        read_by: [this.myUniqueId],
        group_id: group_id,
      });

      if (this.sendingMessageStatus) return;
      this.sendingMessageStatus = true;
      this.performMessageSend(group_id);
    }

    retrySendMessage(event) {
      let failed_element = $(event.currentTarget).closest(".user-message");
      let failed_id = failed_element.data("failed-id");
      if (this.failedMessages[failed_id]) {
        if (room.getConnectionState() != "connected") return false;

        let is_one_user_online = true;
        if (this.selectedParticipantsToMessage.length) {
          is_one_user_online = this.selectedParticipantsToMessage.find((pp) => {
            return (
              typeof Video.videos[this.getParticipantParticipantId(pp)] !=
                "undefined" &&
              typeof Video.videos[this.getParticipantParticipantId(pp)]
                .disconnectTimer == "undefined"
            );
          });
        }
        if (!is_one_user_online) return false;

        let group_id = this.getGroupId(
          this.selectedParticipantsToMessage.map((el) => el)
        );

        this.messageQueue.push(this.failedMessages[failed_id]);
        this.failedMessages[failed_id].failedToSend = false;
        this.addMessageToHTML(this.failedMessages[failed_id]);

        this.scrollToBottom();

        this.failedMessages[failed_id] = {};
        $(event.currentTarget).closest(".message").remove();

        if (this.sendingMessageStatus) return;
        this.sendingMessageStatus = true;
        this.performMessageSend(group_id);
      }
    }

    async performMessageSend(group_id) {
      let element = this.messageQueue.shift();
      if (typeof element == "undefined") {
        this.sendingMessageStatus = false;
        this.mainChat.sendMessage({
          eventName: "sendingMessageStatus",
          status: false,
        });
        return;
      }

      group_id = group_id ?? this.getGroupId(
        this.selectedParticipantsToMessage.map((el) => el)
      );
      if (!group_id) {
        this.selectedChatId = false;
        await this.createGroup()
          .then(async (res) => {
            await this.createLocalGroup(res.data);
            group_id = res.data.id;
            if (!this.selectedChatId) {
              this.selectedChatId = group_id;
              this.lastSelectedChatId = this.selectedChatId;
              this.sendGroupIdChanged(group_id);
            }
          })
          .catch((err) => {
            console.log("Error creating group from perform message send", err);
            group_id = this.getGroupId(
              this.selectedParticipantsToMessage.map((el) => el)
            );
          });
      }
      const encryption_key = await this.getChatEncryptionKey(group_id);
      let unencrypted_text_message = element.message;
      let unencrypted_images = element.images;

      if (encryption_key) {
        element.message = this.encryptString(
          encryption_key,
          unencrypted_text_message
        );
        console.log("Descrypted message", element.message);
        element.images = unencrypted_images.map((image) => {
          return this.encryptString(encryption_key, image);
        });
      }

      await axios
        .post(
          convertPath(`/chat/group/${group_id}/message`),
          {
            message: element.message,
            images: element.images,
            sender: this.myUniqueId,
            sender_name: element.sender_name,
            sender_user_id: element.sender_user_id,
          },
          await electronConfig()
        )
        .then((res) => {
          console.log("Res", res);
          res.data.images = unencrypted_images;
          res.data.message = unencrypted_text_message;
          this.storeGroupMessage(group_id, res.data);
          room.broadcastEndpointMessage({
            chat_message: "message_received_from_kino_user",
            content: {
              ...res.data,
              message: element.message,
              images: element.images,
            },
            group: this.getGroupChatById(group_id),
          });
        })
        .catch((err) => {});
      // setTimeout( () => this.performMessageSend(group_id), 50);
      this.performMessageSend(group_id);
      this.downloadMessageButton();
      renderChatsList();
    }

    async retrieveMessage(message) {
      if (message.group.id == this.selectedChatId) {
        if (this.typingTimout) clearTimeout(this.typingTimout);
        $("#writing-message").html("");
      }

      // check if this message was meant for me
      if (message.group.members.length) {
        if (
          !message.group.members.some(
            (pp) =>
              pp.guest_id == this.myUniqueId ||
              (pp.user_id == USER_ID && USER_ID > 0)
          )
        )
          return;
      }
      const decryption_key = await this.getChatEncryptionKey(message.group.id);
      // finding decryption key
      let decrypted_text = this.decryptString(
        decryption_key,
        message.content.message
      );

      message.content.message = decrypted_text ? decrypted_text : "";

      if (message.content.images && message.content.images.length) {
        message.content.images = await this.decryptImages(
          decryption_key,
          message.content.images
        );
      } else {
        message.content.images = [];
      }

      this.storeGroupMessage(message.group.id, message.content);
      if (!this.getGroupChatById(message.group.id)) {
        await this.createLocalGroup(message.group, true);
      }

      this.mainChat.sendMessage({
        eventName: "chatMessageReceived",
        ...message,
      });
      if (message.group.id == this.selectedChatId) {
        updateChatBadge(message.group.id,0);
        this.addMessageToHTML({
          user_id: message.content.sender,
          sender_name: message.content?.sender_name,
          sender_user_id: message.content?.sender_user_id,
          message: message.content.message,
          images: message.content.images,
          date: message.content.created_at,
          read_by: message.group.read_by,
        });
        this.scrollToBottom();
      } else {
        this.addGroupNotification(message.content.group_id);
        if (!this.isRecordingOrLiveStream()) {
          Video.chatMessageReceived({
            participants: message.group.members,
            group_id: message.content.group_id,
            message: message.content.message,
            images: message.content.images,
            sender_guest_id: message.content.sender,
            participant_id: this.getParticipantParticipantId(
              message.content.sender
            ),
            sender_name:
              message.content?.sender_name &&
              message.content?.sender_name !== "N/A"
                ? message.content?.sender_name
                : this.getParticipantDisplayName(message.content.sender),
            group_name: this.getGroupName(message.group.members),
            groupNotifications: this.groupNotifications.find(
              (group) => group.group_id == message.content.group_id
            ).notifications,
          });
        }
      }

      this.downloadMessageButton();
    }

    isMyMessage(message) {
      console.log("Is my Message", message);
      if (
        message.user_id == this.myUniqueId ||
        (USER_ID > 0 && message.sender_user_id == USER_ID)
      )
        return true;
    }

    // <span class="read-by"><i class="fas fa-eye"></i> ${read_by.map(reader => this.getParticipantDisplayName(reader)).join(', ') }</span>
    // sender, message_content, message_images, message_time, read_by, failedToSend=false
    addMessageToHTML(props) {
      console.log(props);
      let normal_text = $("<span />", {
        html: props.message,
      });
      if (normal_text.find(".emoji-icon").length < 4)
        normal_text.find(".emoji-icon").text("");
      normal_text = normal_text.text();

      if (!props.message && !props.images && !props.images.length) return;

      props.message = props.message
        ? sanitizeHtml(props.message, {
            allowedTags: ["span", "br", "p"],
            allowedAttributes: {
              span: ["class"],
              img: ["src"],
            },
            allowedSchemesByTag: {
              img: ["data"],
            },
          })
        : "";

      props.userName = sanitizeHtml(
        props.sender_name !== "N/A"
          ? props.sender_name
          : this.getParticipantDisplayName(props.user_id),
        this.sanitizeNoOptions
      );

      const myMessage = this.isMyMessage(props);
      props.message = this.replaceURLWithHTMLLinks(
        props.message,
        myMessage ? "text-white" : ""
      );
      // card 120
      $("#chat-message-container").append(`
              <div class="message ${myMessage ? "text-right" : "text-left"}">
                  <div class="message-content">
                      <h6 class="user-name">${
                        props.userName.length >= 30
                          ? props.userName.substring(0, 30) + "..."
                          : props.userName
                      }</h6>
                      <div class="message-body">
                          <div class="user-message ${
                            myMessage ? "user-message-right" : "user-message-left"
                          }" ${
        props.failed_id ? `data-failed-id="${props.failed_id}"` : ""
      }>

                              ${
                                props.images && props.images.length
                                  ? `
                                  <div class="images">
                                      ${props.images
                                        .map((msg) => `<img src="${msg}" >`)
                                        .join("")}|
                                  </div>
                              `
                                  : ""
                              }

                              ${
                                props.message
                                  ? `
                                  <div class="message-content${
                                    normal_text.length == 0 ? " no-text" : ""
                                  }">
                                      ${props.message}
                                  </div>
                              `
                                  : ``
                              }
                              ${
                                props.failedToSend
                                  ? `
                                  <div class="retry-message"><i class="fas fa-exclamation-circle"></i> We couldn't send the message, click to retry.</div>
                              `
                                  : ``
                              }

                          </div>
                      </div>
                      <div class="message-header">
                              <span class="message-time">${this.formatDate(
                                props.date
                              )}</span>
                      </div>
                  </div>
              </div>
          `);

      // end card 120
    }
    formatDate(dateString) {
      const date = moment(dateString);
      const currentDate = moment();
      const diffInMilliseconds = currentDate.diff(date, "milliseconds");
      const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
      const oneWeek = 7 * oneDay; // Number of milliseconds in a week

      if (diffInMilliseconds < oneDay) {
        // If it's today, show only time
        return date.format("h:mm a"); // Time format
      } else if (diffInMilliseconds < oneWeek) {
        // If older than today but within a week, show day and time
        return date.format("ddd, h:mm a"); // Day and time format
      } else {
        // If older than a week, show date and time
        return date.format("Do MMM YYYY h:mma"); // Date and time format
      }
    }

    retrieveReadMessage(message) {}

    sendReadMessage(participants) {
      let message = {
        message: "read_by",
        participants: participants.map((pp) => pp),
        by: this.myUniqueId,
      };
      room.broadcastEndpointMessage(message);
    }

    endpointMessageReceived(user, message) {
      console.log("Endpoint message received", message);
      if (!permissions.hasChat()) {
        return;
      }
      if (message.type) return;

      // received a new message
      if (message.chat_message) return this.retrieveMessage(message);

      // someone has read the message
      if (message.read_by) return this.retrieveReadMessage(message);

      if (message.message_type && message.message_type == "typing_message")
        return this.receiveTypingMessage(message);
    }

    // clicking a chat
    async selectGroupChat(e) {
      e.preventDefault();
      if ($("#chat-nav-tab").hasClass("active")) {
        // card 473
        this.closeChatList();
        // end card 473
        $("#message-text-field").focus();
        let group_id = $(e.currentTarget).data("group")
          ? $(e.currentTarget).data("group")
          : null;

        if (group_id) {
          this.selectGroupChatById(group_id);
        } else if ($(e.currentTarget).data("participant")) {
          this.clearSelectedGroupChatHTML();
          this.selectedParticipantsToMessage = [];
          this.addToSelectedParticipantToMessageById(
            $(e.currentTarget).data("participant")
          );
          this.selectedChatId = false;
          this.clearChat();
          if (!this.participantHasChat($(e.currentTarget).data("participant"))) {
            setTimeout(() => {
              this.addChatNotAvailable();
            }, 500);
          }
        }

        // card 359
        this.downloadMessageButton();
        // end card 359
      }
    }

    async setChatselected(chat) {

        let group_id = chat?.group;

        if (group_id) {
            this.selectGroupChatById(group_id);
        } else if (chat.pId) {
            this.clearSelectedGroupChatHTML();
            this.selectedParticipantsToMessage = [];
            this.addToSelectedParticipantToMessageById(chat.pId);
            this.selectedChatId = false;
            this.clearChat(false);
            if (!this.participantHasChat(chat.pId)) {
                setTimeout(() => {
                    this.addChatNotAvailable();
                }, 500);
            }
        }
        $("#message-text-field").trigger('focus');


    }

    addChatNotAvailable() {
      $("#chat-message-container").append(`
              <div class="chat-na-container">
                  <div class="chat-na-box">
                      <p>The chat is disabled for this person.</p>
                  </div>
              </div>
          `);
    }

    selectGroupChatById(group_id, useHtml = true) {
      if (group_id) {
        setSelectedChatActive(group_id);
        this.selectedParticipantsToMessage = [];
        if (useHtml) this.clearSelectedGroupChatHTML();
        const group = this.groups.find((group) => group.id == group_id);
        if (!group) return;

        if (group.id == group_id) {
          this.selectedChatId = group.id;
          this.lastSelectedChatId = this.selectedChatId;
          group.members.forEach((pp) => {
            // prevent from adding yourself in this selected group chat
            if (
              pp.guest_id != this.myUniqueId &&
              (USER_ID == 0 || pp.user_id != USER_ID)
            ) {
              this.selectedParticipantsToMessage.push(pp.guest_id);
              // if(useHtml) this.addToSelectedParticipantToMessageHTML(pp.guest_id, pp.displayName);
              if (useHtml)
                this.addToSelectedParticipantToMessageHTML(
                  pp.guest_id,
                  pp.displayName
                );
            }
          });
        }

        if (!this.selectedParticipantsToMessage.length) {
          this.makePublicChatVisible();
        }
        this.readMessagesbyGroupId(group_id);
        this.showMessagesByGroupId(group_id);

        this.scrollToBottom();
      }
      this.downloadMessageButton();
    }

    showMessagesByGroupId(group_id) {
      let group = this.groups.filter((group) => group.id == group_id);
      if (!group.length) return;
      group = group[0];
      this.clearChat();
      if (!this.messages[group_id]) {
        return;
      }
      this.messages[group_id].map((message) => {
        this.addMessageToHTML({
          user_id: message.sender,
          sender_name: message.sender_name,
          sender_user_id: message.sender_user_id,
          message: message.message,
          images: message.images,
          date: message.created_at,
          read_by: group.read_by,
          group_id: group_id,
        });
      });
    }

    sendTypingMessage(e) {
      if (this.sendingTypingMessageToUser) return;
      this.sendingTypingMessageToUser = true;
      setTimeout(() => {
        this.sendingTypingMessageToUser = false;
      }, 3000);
      room.broadcastEndpointMessage({
        message_type: "typing_message",
        chat_id: this.selectedChatId,
        sender: this.myUniqueId,
      });
    }

    receiveTypingMessage(message) {
      // console.log("Received typing message", message);
      // console.log("My chat id",this.selectedChatId);
      this.mainChat.sendMessage({
        eventName: "typingStarted",
        ...message,
      });
      if (message.chat_id == this.selectedChatId && message.chat_id) {
        if (this.typingTimout) clearTimeout(this.typingTimout);
        $("#writing-message").html(
          `<i class="fas fa-pen"></i> <strong>${this.getParticipantDisplayName(
            message.sender
          )}</strong> is typing...`
        );
      }
      this.typingTimout = setTimeout(() => {
        $("#writing-message").html("");
      }, 4000);
    }

    /**
     *      HTML MANIPULATOR FOR CLASSES
     *      HTML SETTERS
     *
     *
     */
    closeChatSelection(evt) {
      if (!$(evt.target).closest(".select-chat-list").length) {
        this.closeAddParticipantList();
        this.closeChatList();
      }

      // card 291
      if (
        !$(evt.target).closest("#myConvoPanel").length &&
        $("#myConvoPanel").hasClass("open") &&
        !$(evt.target).hasClass("download-js-link") &&
        !evt.target.closest(".chatBubbleContainer") &&
        evt?.target?.tagName !== "HTML" &&
        evt?.target?.tagName !== "INPUT" &&
        !evt.target.closest(".menu-content")
      ) {
        // card id 829
        console.trace("Called CloseChatSelection", evt.target);
        CONV_STORAGE.closePanel();
        // end card id 829
        this.closeAddParticipantList();
        this.closeChatList();
        this.lastSelectedChatId = this.selectedChatId;
        this.selectedChatId = false;
      }
      // end card 291
    }

    closeAddParticipantList() {
      if (
        $("#chat-content-container").find(".select-user-list").hasClass("active")
      ) {
        $("#chat-content-container")
          .find(".select-user-list")
          .removeClass("active");
      }
    }
    openAddParticipantList() {
      if (
        !$("#chat-content-container").find(".select-user-list").hasClass("active")
      ) {
        $("#chat-content-container").find(".select-user-list").addClass("active");
      }
    }

    getUserButton(name) {
      return `<div class="user-icon" title="${name}" data-toggle="tooltip" data-placement="top">${this.profileImgUser}</div>`;
    }

    // appending someone in to chat with
    addParticpiantInGroupChatHTML(pId, displayName) {
      // card 120
      $("#add-chat-participant-list").append(`
              <li class="list-item">
                  <a class="participant-item" data-id="${pId}">
                      <div class="profile-img">
                          ${this.getUserButton(
                            sanitizeHtml(
                              displayName.replace(/^\s+|\s+$/g, ""),
                              this.sanitizeNoOptions
                            )
                          )}
                      </div>
                      <div class="profile-desc">
                          <div class="full-name">
                              <span>${sanitizeHtml(
                                displayName.replace(/^\s+|\s+$/g, ""),
                                this.sanitizeNoOptions
                              )}</span>
                          </div>
                      </div>
                  </a>
              </li>
          `);
      // end card 120
    }

    // card 120
    addToSelectedParticipantToMessageHTML(pId, displayName) {
      $(
        "#chat-content-container .chat-list-participant-group li.pub-chat"
      ).addClass("d-none");
      $(
        "#chat-content-container .messages .chat-list-participant-group li:last"
      ).before(
        `<li data-id="${pId}" class="user-list-children">
                  <div class="chat-list-participant-item">
                      ${this.getUserButton(
                        sanitizeHtml(
                          displayName.replace(/^\s+|\s+$/g, ""),
                          this.sanitizeNoOptions
                        )
                      )}
                      <div class="user-name">
                          <span>${sanitizeHtml(
                            displayName.replace(/^\s+|\s+$/g, ""),
                            this.sanitizeNoOptions
                          )}</span>
                      </div> <i class="fas fa-times" title="Remove Participant" data-toggle="tooltip" data-placement="top"></i>
                  </div>
              </li>`
      );
      this.clearChat();
      $("#search-new-particpant").val("");
      let userListLength = $(
        `.chat-list-participants .chat-list-participant-group li[data-id]:not(.d-none)`
      ).length;
      if (userListLength > 5) {
        // $(`.user-list-children .chat-list-participant-item .user-name:nth-child(${userListLength - 5})`).addClass('d-none')
        $(
          `.chat-list-participants .chat-list-participant-group li[data-id]:not(.d-none)`
        )
          .eq(0)
          .addClass("d-none");
      }
    }

    // end card 120

    clearChat(hasMessages=true) {
      console.trace("clearing chat");
      $("#chat-message-container").empty();
        if(!hasMessages) $("#chat-message-container").html(`<div class="d-flex justify-content-center text-center text-white-50 w-100"><p class="no-messages">No messages to show.</p></div>`);
    }

    clearSelectedGroupChatHTML() {
      $("#chat-content-container .messages .chat-list-participant-group")
        .children()
        .each((index, el) => {
          if (
            !$(el).find("input").length &&
            !$(el).find("div.public-chat").length
          ) {
            $(el).remove();
          }
        });
    }

    makePublicChatVisible() {
      $(
        "#chat-content-container .chat-list-participant-group li.pub-chat"
      ).removeClass("d-none");
    }

    scrollToBottom() {
      let chat_container = document.querySelector("#chat-message-container");
      chat_container.scrollTop = chat_container.scrollHeight;
    }

    makeChatTabActive() {
      $("#conversations-tab-nav").removeClass("active");
      $("#conversations-tab-nav").attr("aria-selected", false);
      $("#conversations-tab").removeClass("active");
      $("#conversations-tab").removeClass("show");
      stopMediaPlayers($("#conversations-tab")); //card 599

      $("#chat-nav-tab").addClass("active");
      $("#chat-nav-tab").attr("aria-selected", true);
      $("#chatting-tab").addClass("active");
      $("#chatting-tab").addClass("show");
    }

    replaceURLWithHTMLLinks(text, color) {
      let httpsPattern =
        /(\b(https?|ftp|file|http):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;
      let wwwPattern = /(^|[^\/])(www\.[\S]+(\b|$))/i;
      let emailPattern = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/i;
      return text
        .replace(
          httpsPattern,
          "<a class='kino-links " + color + "' target='_blank' href='$1'>$1</a>"
        )
        .replace(
          wwwPattern,
          "<a class='kino-links " +
            color +
            "' target='_blank' href='https://$2'>$2</a>"
        )
        .replace(
          emailPattern,
          "<a class='kino-links " +
            color +
            "' href='mailto:$1' target='_blank' >$1</a>"
        );
    }

    openChatInPopUp() {
      console.log("Main chat open popup", this.mainChat);
      if (permissions.hasChat()) {
        this.mainChat.openChatPopup();
      }
    }

    // chat popup api
    registerChatApi() {
      let chat = this;
      this.mainChat.listenMain("getChatsList", chat.getChatsListApi.bind(chat));
      this.mainChat.listenMain("getGroupId", chat.getGroupIdApi.bind(chat));
      this.mainChat.listenMain(
        "getGroupById",
        chat.getGroupChatByIdApi.bind(chat)
      );
      this.mainChat.listenMain(
        "getGroupMessages",
        chat.getGroupMessagesApi.bind(chat)
      );
      this.mainChat.listenMain(
        "typingMessage",
        chat.sendTypingMessageApi.bind(chat)
      );
      this.mainChat.listenMain(
        "addMessageToQueue",
        chat.addMessageToQueue.bind(chat)
      );
      this.mainChat.listenMain(
        "performMessageSend",
        chat.performMessageSendApi.bind(chat)
      );
      this.mainChat.listenMain(
        "countGroupMessages",
        chat.countGroupMessagesApi.bind(chat)
      );
      this.mainChat.listenMain(
        "downloadMessages",
        chat.downloadMessagesApi.bind(chat)
      );
      this.mainChat.listenMain(
        "readGroupMessages",
        chat.readMessagesByGroupIdAPI.bind(chat)
      );
      this.mainChat.listenMain(
        "chat-popoup-close",
        chat.onChatPopupClose.bind(chat)
      );
      this.mainChat.listenMain(
        "getChatsListArray",
        chat.getChatsListArrayApi.bind(chat)
      );
      this.mainChat.listenMain(
        "isParticipantOnline",
        chat.isParticipantOnlineApi.bind(chat)
      );
      this.mainChat.listenMain(
        "createGroupChatFromMenu",
        chat.createGroupChatFromMenuApi.bind(chat)
      );
      this.mainChat.listenMain(
        "addMembersFromMenu",
        chat.addMembersFromMenuApi.bind(chat)
      );
    }

    onChatPopupClose(msg) {
      this.lastSelectedChatId = msg.selectedChatId;
    }
    readMessagesByGroupIdAPI(msg) {
      this.readMessagesbyGroupId(msg.group_id);
    }

    onParticipantsChanged() {
      if (this.mainChat.chatWindow) {
        let participants = room.getParticipants().map((p) => {
          return {
            guest_id: p.getProperty("guest_id"),
            _displayName: p.getDisplayName(),
            pid: p.getId(),
          };
        });
        this.mainChat.sendMessage({
          eventName: "participantsChanged",
          participants,
        });
      }
    }

    sendGroupIdChanged(group_id) {
      this.mainChat.sendMessage({
        eventName: "selectedGroupChanged",
        group_id: group_id,
      });
    }
    downloadMessagesApi(msg) {
      this.selectedChatId = msg.group_id;
      this.downloadMessages();
    }

    getChatsListArrayApi(msg){
        console.log("Get chats list array", msg);
        this.mainChat.sendMessage({
            msgId: msg.msgId,
            chats: this.getChatsListArray(),
          });
    }

    countGroupMessagesApi(msg) {
      let messagesCount = 0;
      let messages = this.messages[msg.group_id];
      messagesCount = messages?.length || 0;
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          messages: messagesCount,
        });
      }
    }

    performMessageSendApi(msg) {
      this.selectedParticipantsToMessage = msg.participants;
      this.performMessageSend(msg.group_id);
    }

    addMessageToQueue(msg) {
      this.messageQueue.push({ ...msg.message, date: moment() });
    }

    sendTypingMessageApi(msg) {
      try {
        room.broadcastEndpointMessage({
          message_type: "typing_message",
          chat_id: msg.selectedChatId,
          sender: this.myUniqueId,
        });
      } catch (error) {}
    }

    getGroupIdApi(msg) {
      let _participants = msg._participants;
      let groupId = false;
      _participants.push(this.myUniqueId);
      let groups = this.groups.filter((group) => {
        if (_participants.length == 1 && group.members.length == 0) return true; // geting public chat
        if (
          _participants.length == group.members.length &&
          group.members.every(
            (pp) =>
              _participants.includes(pp["guest_id"]) ||
              (USER_ID > 0 && pp["user_id"] == USER_ID)
          )
        )
          return true;
      });
      if (groups.length) groupId = groups[0].id;
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          group_id: groupId,
        });
      }
    }
    getGroupMessagesApi(msg) {
      let messages = this.messages[msg.group_id];
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          messages: messages,
        });
      }
    }
    getGroupChatByIdApi(msg) {
      let group_id = msg.group_id;
      let group = this.groups.find((group) => group.id == group_id);
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          group: group,
        });
      }
    }

    getChatsListApi(msg) {
      let participants = this.getChatsListArray();

      this.groupUniqueParticipants().forEach((el) => {
        participants.push({
          pId: el,
          group: null,
          name: this.getParticipantDisplayName(el),
          isChat: false,
        });
      });

      // perform search
      let found_items = participants.filter(
        (pp) =>
          pp.name
            .toLowerCase()
            .search($("#search-new-particpant").val().toLowerCase()) > -1
      );
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          items: found_items,
        });
      }
    }

    isParticipantOnlineApi(msg) {
        const pid = msg.pid;
        this.mainChat.sendMessage({
            msgId: msg.msgId,
            online: this.isParticipantOnline(pid),
        });
    }

    createGroupChatFromMenuApi(msg) {
        const pids = msg.participants;
        createGroupChatFromMenu(pids).then((newChat) => {
            this.mainChat.sendMessage({
                msgId: msg.msgId,
                newChat: newChat,
            });
        });
    }

    addMembersFromMenuApi(msg){
        const members = msg.members;
        addMembersFromMenu(msg.group_id,members).then((data) => {
            this.mainChat.sendMessage({
                msgId: msg.msgId,
                newMembers: data,
            });
        });
    }
  }
